import React from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      icon: <FaGithub className="w-5 h-5 text-white" />,
      href: "https://github.com/nidhisoni01",
      label: "GitHub",
      bg: "bg-gray-900 hover:bg-gray-800",
    },
    {
      icon: <FaLinkedin className="w-5 h-5 text-white" />,
      href: "https://www.linkedin.com/in/nidhi-soni-b06449250",
      label: "LinkedIn",
      bg: "bg-[#0077B5] hover:bg-[#005582]",
    },
    {
      icon: <FaEnvelope className="w-5 h-5 text-white" />,
      href: "mailto:soninidhi630@gmail.com",
      label: "Email",
      bg: "bg-[#EA4335] hover:bg-[#C5221F]",
    },
  ];

  return (
    <footer className="relative py-6 px-4 sm:px-6 lg:px-8 border-t border-[#3A3A3A] bg-[#2E2E2E] text-gray-300 rounded-t-2xl shadow-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {/* Copyright Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-gray-300 text-center md:text-left"
          >
            <p className="flex items-center gap-2">
              © {currentYear}{" "}
              <span className="font-semibold text-white">Nidhi Soni</span>. Made with{" "}
              <Heart className="w-4 h-4 text-pink-500 fill-pink-500 animate-pulse" />{" "}
              All rights reserved.
            </p>
          </motion.div>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center gap-4"
          >
            {socialLinks.map((social, index) => (
              <motion.a
                key={index}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className={`w-10 h-10 rounded-full flex items-center justify-center shadow-md transition-all duration-300 ${social.bg}`}
                whileHover={{ scale: 1.15, y: -2 }}
                whileTap={{ scale: 0.95 }}
                aria-label={social.label}
              >
                {social.icon}
              </motion.a>
            ))}
          </motion.div>
        </div>

        {/* Bottom Text */}
        <div className="mt-8 pt-6 border-t border-[#3A3A3A] text-center">
          <p className="text-gray-400 text-sm">
            Built with <span className="font-semibold text-white">React</span>,{" "}
            <span className="font-semibold text-sky-400">Tailwind CSS</span>, and lots of{" "}
            <span className="text-pink-500 font-semibold">passion</span>.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
